/* eslint-disable react/prop-types */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
import React from 'react';

// Formatter for modes of issuance
export const modeFormatter =
  (formatMessage) =>
  ({ option }) => (
    <div key={option.value}>
      {formatMessage({
        id: `ui-inventory.modesOfIssuance.name.${option.label}`,
        defaultMessage: option.label,
      })}
    </div>
  );

// Formatter for classification types (MultiSelection)
export const classificationFormatter =
  (formatMessage) =>
  ({ option }) => (
    <div key={option.value}>
      {formatMessage({
        id: `ui-inventory.classificationTypes.name.${option.label}`,
        defaultMessage: option.label,
      })}
    </div>
  );

// Formatter for classification types (Selection)
export const classificationSelectionFormatter =
  (formatMessage) =>
  ({ option }) =>
    formatMessage({
      id: `ui-inventory.classificationTypes.name.${option.label}`,
      defaultMessage: option.label,
    });
